import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import paths from 'paths';
import { dt, getLocale } from 'l10n';
import { formatDateDash, formatUnixDateDMY } from 'utils/formatDate';
import { getMessageText } from 'utils/notifications';

const ItemNotification = ({ data, history }) => {
    const { type, data: { date, is_read, meta }} = data;

    const onProfileClick = () => {
        history.push(paths.profile.toPath({ nick: meta.user.nick }));
    };

    const onLinkClick = () => {
        history.push(meta.url);
    };

    const fr = getLocale() === 'fr';

    return (
        <div className="item">
            <div className="time">{formatDateDash(date)}</div>
            <div className={`status ${!is_read ? 'active' : ''}`}/>

            {(!fr && type === "tip") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    {dt('notifications', "You have received")}
                    <div className="username margin" onClick={e => onLinkClick(e)}>{dt('notifications', '%1 tokens', meta.amount)}</div>
                    {dt('notifications', "from")}
                    <div className="username margin-left" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                </div>
            )}

            {(fr && type === "tip") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', "You have received")}
                    <div className="username margin" onClick={e => onLinkClick(e)}>{dt('notifications', '%1 tokens', meta.amount)}</div>
                </div>
            )}

            {(type === "tip_private_received") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', "has sent you")}
                    <div className="username margin" onClick={e => onLinkClick(e)}>{dt('notifications', '%1 tokens privately!', meta.amount)}</div>
                </div>
            )}

            {(!fr && type === "new_follower") && (
                <div className={`message ${!is_read ? 'new' : ''}`} onClick={e => onLinkClick(e)}>
                    {dt('notifications', 'You have a new follower')}
                    <div className="username margin-left" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                </div>
            )}

            {(fr && type === "new_follower") && (
                <div className={`message ${!is_read ? 'new' : ''}`} onClick={e => onLinkClick(e)}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', 'You have a new follower')}
                </div>
            )}

            {(!fr && type === "guestbook_message") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    {dt('notifications', getMessageText("guestbook_first"))}
                    <div className="username margin" onClick={e => onLinkClick(e)}>
                        {dt('notifications', getMessageText("new_message"))}
                    </div>
                    {dt('notifications', getMessageText("guestbook_second"))}
                    <div className="username margin-left" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                </div>
            )}

            {(fr && type === "guestbook_message") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', getMessageText("guestbook_first"))}
                    <div className="username margin" onClick={e => onLinkClick(e)}>
                        {dt('notifications', getMessageText("new_message"))}
                    </div>
                    {dt('notifications', getMessageText("guestbook_second"))}
                </div>
            )}

            {type === "gift" && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className={meta.user.id === 0 ? "username username_anonymous" : "username"} onClick={e => onProfileClick()}>{meta.user.nick}</div>
                    {dt('notifications', 'has given you a')}
                    <div className="username margin-left" onClick={e => onLinkClick()}>{dt('notifications', 'virtual gift!')}</div>
                </div>
            )}

            {type === "membership_gift" && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', "has given you a")}
                    <div className="username margin" onClick={e => onLinkClick(e)}>{dt('notifications', "XXL membership")}</div>
                    {dt('notifications', "for %1 days!", meta.duration)}
                </div>
            )}

            {type === "wall" && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    <div className="username" onClick={e => onProfileClick(e)}>{meta.user.nick}</div>
                    {dt('notifications', getMessageText('wall_short'))}
                    <div className="username margin-left" onClick={e => onLinkClick()}>{dt('notifications', 'the Wall')}</div>
                </div>
            )}

            {(type === "user_membership_expired" || type === "user_membership_almost_expired") && (
                <div className={`message ${!is_read ? 'new' : ''}`}>
                    {dt('notifications', getMessageText(type), formatUnixDateDMY(meta.expiration_date))}
                    <div className="username margin-left" onClick={e => onLinkClick()}>{dt('notifications', 'Renew now!')}</div>
                </div>
            )}
    
            {(type === "stream_record_error") && (
              <div className={`message ${!is_read ? 'new' : ''}`}>
                  {dt('notifications', getMessageText(type))}
              </div>
            )}
        </div>
    )
};

ItemNotification.propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(ItemNotification);



// WEBPACK FOOTER //
// ./src/components/notification/ItemNotification.js